import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppFloat from './WhatsAppFloat';
import { trackVisit } from '../lib/tracking';
import { useSettings } from '../context/SettingsContext';

export default function Layout() {
  const location = useLocation();
  const { ready, loading } = useSettings();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackVisit(location.pathname);
  }, [location.pathname]);

  return (
    <div className={`flex flex-col min-h-screen bg-white transition-opacity duration-200 ${ready || !loading ? 'opacity-100' : 'opacity-0'}`}>
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
